import React from "react";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { withRouter } from 'withRouter';
import { compose } from "redux";
import { createStructuredSelector } from "reselect"
import localForage from "localforage";
import reducerDep from 'containers/Deployment/reducer'
import sagaDep from 'containers/Deployment/saga'
import reducer from "containers/App/reducer";
import loginReducer from "containers/Login/reducer";
import loginSaga from "containers/Login/saga";
import injectReducer from "utils/injectReducer";
import injectSaga from "utils/injectSaga";
import appMessages from "utils/messages";
import DeactivatedWorkspace from "containers/Settings/Workspace/DeactivatedWorkspace";
import SuspendedWorkspace from "containers/Settings/Workspace/SuspendedWorkspace";
import IdleScreenDetector from "../IdleScreenDetector";
import VerificationCode from "containers/Settings/User/Detail/components/VerificationCode";
import PreApplicationWrapper from "./PreApplicationWrapper";
import PreLoaderSidebar from "../../components/PreLoader/PreLoaderSidebar";
import { fetchWorkspaceDetailRequest } from "containers/Settings/Workspace/actions";
import { logout, updateDeviceType, updateSidebarDisplay } from "containers/App/actions";
import { makeSelectDevice } from "containers/App/selectors";
import { selectWorkspaceRequest } from "containers/Login/actions";
import { getDetailRole } from "containers/Settings/AccessRole/selectors";
import { makeSelectMe } from "containers/Settings/User/selectors";
import { getStartedTrackerRequest, updateStartedTrackerRequest } from "containers/Settings/Workspace/actions";
import { getTrackerInfo, makeSelectFetchWorkspace } from "containers/Settings/Workspace/selectors";
import { defaultNotifier } from "functions/notificationHandler";
import { routeMapping } from "routes";
import { socket } from "socket";
import { isPermitted } from "utils/permissions";
import { getPendingDeviceRequest } from 'containers/Deployment/actions';

class LeftPanel extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    showDemoApp: false,
  };

  logout = async () => {
    this.props.logout();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userData");
    localForage.setItem("activePartnerId", null);
    localForage.setItem("hideMaintenanceBanner", false);

    // Remove YBug widget on logout
    window.dispatchEvent(new Event('ybug:cleanup'));

    setTimeout(() => {
      this.props.router.navigate(routeMapping.LOGIN.path);
    }, 100);
  };

  logoutSession = () => {
    this.logout();
    return defaultNotifier('Session timed out.');
  }

  hideNav = () => {
    document.getElementById("sidebar").classList.remove("sidebar_visible");
    document.getElementById("overlay").classList.remove("overlay_visible");
  };

  // eslint-disable-next-line
  componentWillReceiveProps(nextProps) {
    const isNextSmallerDevice =
      nextProps.deviceSizeType === "tablet" ||
      nextProps.deviceSizeType === "mobile";
    const isSmallerDevice =
      this.props.deviceSizeType === "tablet" ||
      this.props.deviceSizeType === "mobile";

    const { tracker } = this.props;

    if (
      nextProps.deviceSizeType === "mobile" &&
      nextProps.deviceSizeType !== this.props.deviceSizeType
    ) {
      return this.props.updateSidebarDisplay(true);
    }

    if (
      tracker &&
      nextProps.tracker &&
      tracker.completedCount !== nextProps.tracker.completedCount &&
      nextProps.tracker.completedCount === nextProps.tracker.taskCount
    ) {
      return defaultNotifier({ ...appMessages.congratulationsSetupComplete });
    }

    if (
      !isSmallerDevice &&
      nextProps.deviceSizeType === "tablet" &&
      nextProps.deviceSizeType !== this.props.deviceSizeType &&
      isNextSmallerDevice
    ) {
      return this.props.updateSidebarDisplay(true);
    }

    if (
      isSmallerDevice &&
      nextProps.deviceSizeType !== this.props.deviceSizeType &&
      nextProps.deviceSizeType === "desktop"
    ) {
      return this.props.updateSidebarDisplay(false);
    }
  }

  componentDidMount() {
    const { workspace } = this.props;

    this.props.updateDeviceType({
      width: window.innerWidth,
      isMobile: isMobile,
    });

    if (this.props.deviceSizeType === "mobile") {
      return this.props.updateSidebarDisplay(true);
    }

    if (this.props.me && isPermitted({ id: "devices" }, this.props.detailRole)) {
      this.props.getPendingDeviceRequest({
        includeDemoData: workspace.demoModeEnabled
      });
    }
  }

  onSubmitCode = (codes, type) => {
    const code = codes.reduce((sum, item) => `${sum}${item}`);

    let payload = this.props.wsData;

    if (type === "code") {
      payload = {
        ...this.props.wsData,
        twoFactorCode: code,
      };
    }

    if (type === "recoveryKey") {
      payload = {
        ...this.props.wsData,
        twoFactorRecoveryKey: code,
      };
    }

    return this.props.selectWorkspaceRequest(payload, {
      push: this.props.router.navigate,
      onCallback: () => {
        socket.close();
        this.props.setShowVerificationCode(false);
      },
    });
  };

  onClose = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");

    this.props.router.navigate(routeMapping.LOGIN.path);
  };

  render() {
    const { workspace } = this.props

    if (this.props.isLoading) {
      return <PreLoaderSidebar />;
    }

    if (this.props.showWarning) {
      return <DeactivatedWorkspace workspace={this.props.selectedWs} />;
    }

    if (this.props.isSuspended) {
      return (
        <SuspendedWorkspace
          workspace={this.props.selectedWs}
          onClose={this.onClose}
        />
      );
    }

    if (this.state.showDemoApp) {
      return (
        <PreApplicationWrapper
          getStartedTrackerRequest={getStartedTrackerRequest}
          updateStartedTrackerRequest={updateStartedTrackerRequest}
          onClose={() => this.setState({ showDemoApp: false })}
        />
      );
    }

    if (this.props.showVerificationCode) {
      return (
        <VerificationCode
          onSubmit={this.onSubmitCode}
          workspace={workspace}
          onClose={() => this.props.setShowVerificationCode(false)}
        />
      );
    }

    return (
      <>
        <IdleScreenDetector logout={this.logoutSession} />
        <div
          id="overlay"
          className="overlay mobile-only"
          onClick={this.hideNav}
        />
      </>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  tracker: getTrackerInfo(),
  deviceSizeType: makeSelectDevice(),
  detailRole: getDetailRole(),
  me: makeSelectMe(),
  workspace: makeSelectFetchWorkspace(),
});

const withConnect = connect(mapStateToProps, {
  logout,
  getPendingDeviceRequest,
  getStartedTrackerRequest,
  fetchWorkspaceDetailRequest,
  updateDeviceType,
  selectWorkspaceRequest,
  updateSidebarDisplay,
  updateStartedTrackerRequest,
});

const withReducer = injectReducer({ key: "global", reducer });
const withLoginReducer = injectReducer({ key: "login", reducer: loginReducer });
const withLoginSaga = injectSaga({ key: "login", saga: loginSaga });

const withDepSaga = injectSaga({ key: 'deployment', saga: sagaDep });
const withDepReducer = injectReducer({
  key: 'deployment',
  reducer: reducerDep,
});

export default withRouter(
  compose(withReducer, withLoginReducer, withLoginSaga, withDepReducer, withDepSaga, withConnect)(LeftPanel)
);
